import { Component, input, InputSignal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

interface IDismissibleDialog {
  onDismiss(): void;
}

/**
 * Close (X) button placed in the top-right corner of a dialog.
 * It is appended to every opened dialog by `DialogCloseButtonService`, so it should not be added to dialog templates.
 */
@Component({
  imports: [MatIconButton, MatIcon, TranslateModule],
  selector: 'app-dialog-close-button',
  styleUrl: './dialog-close-button.component.scss',
  templateUrl: './dialog-close-button.component.html',
})
export class DialogCloseButtonComponent {
  public dialogRef: InputSignal<MatDialogRef<unknown>> = input.required<MatDialogRef<unknown>>();

  public close(): void {
    const ref = this.dialogRef();
    const instance = ref.componentInstance;

    if (this.isDismissibleDialog(instance)) {
      instance.onDismiss();
    } else {
      ref.close();
    }
  }

  private isDismissibleDialog(instance: unknown): instance is IDismissibleDialog {
    return typeof (instance as Partial<IDismissibleDialog> | null)?.onDismiss === 'function';
  }
}
